(function (TIPTOE, w, d, $) {
  const log = TIPTOE.HAS_DEBUG
    ? window.console.log.bind(window, 'Product Gallery:')
    : function () {};

  // Flickity options
  const options = {
    initialIndex: 1,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
    cellAlign: 'left',
  };

  // Init Flickity
  const $sliders = $('.js-product-gallery__container');

  $sliders.each(function (index, slider) {
    $(slider).on('ready.flickity', function () {
      setTimeout(function () {
        $(window).trigger('resize');
        $(slider).flickity('resize');
      }, 3000);
    });

    $(slider).flickity(options);
    $(slider).flickity('resize');

    // previous"
    $('.product-gallery__arrow--prev').on('click', function () {
      $(slider).flickity('previous');
    });

    // next
    $('.product-gallery__arrow--next').on('click', function () {
      $(slider).flickity('next');
    });
  });

  const $filters = $('.js-filter');
  const $galeries = $('.product-gallery');

  $filters.click(function (e) {
    e.preventDefault();

    if ($(this).closest('.products-filters__item').hasClass('is-active')) {
      return;
    }

    const data = $(this).data('filter');

    $galeries.removeClass('is-visible');
    $(`.product-gallery[data-filtered="${data}"]`).addClass('is-visible');

    $filters.closest('.products-filters__item').removeClass('is-active');
    $(this).closest('.products-filters__item').addClass('is-active');

    $sliders.each(function (index, slider) {
      $(slider).flickity('resize');
    });
  });
})(TIPTOE, window, document, jQuery);
